import { Button } from '@chakra-ui/react';

export const SkipButton = ({
  buttonText = '',
  onSkip = () => {},
  ...props
}) => {
  return (
    <Button
      variant="secondary"
      _hover={{}}
      _active={{}}
      onClick={onSkip}
      {...props}
    >
      {buttonText}
    </Button>
  );
};

export const StopButton = ({ onClick = () => {}, ...props }) => {
  return (
    <Button
      variant="secondary"
      color="pastel-1-dark"
      borderColor="pastel-1-dark"
      _hover={{}}
      _active={{}}
      onClick={onClick}
      {...props}
    >
      Stop Flow
    </Button>
  );
};
